import { Product } from "./product";
import { ReceiptProduct } from "./receipt-product";
import { SystemField } from "./system-field";

export class ReceiptProductDetail extends SystemField{
     
     receipt_prod_id?:string;
     product_id?:string;
     trans_uom_id?:string;
     base_uom_id?:string;
     location_id?:string;
     qty?:number;
     unit_cost?:number;
     discount_amount?:number;
     discount_rate?:number;

     //formula fields
     total_cost?:number;

     //parent relationship
     product?:Product;
     receipt_product?:ReceiptProduct;

     //children relationship
}
